import { DatePreset, MetricCardConfig } from "./types"

export const DATE_PRESETS: Array<{
  id: DatePreset
  label: string
  days: number
}> = [
  { id: "yesterday", label: "Yesterday", days: 1 },
  { id: "last7Days", label: "Last 7 Days", days: 7 },
  { id: "last14Days", label: "Last 14 Days", days: 14 },
  { id: "last30Days", label: "Last 30 Days", days: 30 },
]

export const CUSTOMER_ACQUISITION_METRICS = [
  {
    id: "newCustomers",
    label: "New Customers Acquired",
    format: "number" as const,
  },
  {
    id: "ncRevs",
    label: "Revenue from New Customers",
    format: "currency" as const,
  },
  {
    id: "cac",
    label: "Customer Acquisition Cost",
    format: "currency" as const,
  },
  { id: "aMer", label: "aMER", format: "decimal" as const },
]

export const RETENTION_METRICS = [
  {
    id: "avgOrderSequence",
    label: "Avg Order Sequence",
    format: "decimal" as const,
  },
  {
    id: "repeatRevs",
    label: "Revenue from Repeat Customers",
    format: "currency" as const,
  },
]

export const BRAND_METRICS = [
  { id: "brandValue", label: "Brand Value", format: "currency" as const },
  {
    id: "brandedSearches",
    label: "Branded Searches",
    format: "number" as const,
  },
  {
    id: "baselineRevenuePercent",
    label: "Baseline Revenue (% of Total)",
    format: "percent" as const,
  },
]

export const MARKETING_EFFICIENCY_METRICS = [
  { id: "mer", label: "MER", format: "decimal" as const },
  { id: "aMer", label: "aMER", format: "decimal" as const },
  {
    id: "totalModeledPaidRevs",
    label: "Total Modeled Paid Revs",
    format: "currency" as const,
  },
  { id: "roas", label: "ROAS", format: "decimal" as const },
]

export const CONSIDERATION_METRICS = [
  { id: "sessions", label: "Sessions", format: "number" as const },
  {
    id: "engagedSessions",
    label: "Engaged Sessions",
    format: "number" as const,
  },
  {
    id: "baselineSessions",
    label: "Baseline Sessions",
    format: "number" as const,
  },
]

export const CONVERSION_METRICS = [
  {
    id: "revenuePerSession",
    label: "Revenue Per Session",
    format: "currency" as const,
  },
  {
    id: "baselineRevenuePerSession",
    label: "Baseline Revenue per Session",
    format: "currency" as const,
  },
]

export const METRIC_CARD_CONFIGS: MetricCardConfig[] = [
  {
    id: "customerAcquisition",
    title: "Customer Acquisition",
    metrics: CUSTOMER_ACQUISITION_METRICS.map(m => ({ ...m, value: null })),
  },
  {
    id: "retention",
    title: "Retention",
    metrics: RETENTION_METRICS.map(m => ({ ...m, value: null })),
  },
  {
    id: "brand",
    title: "Brand",
    metrics: BRAND_METRICS.map(m => ({ ...m, value: null })),
  },
  {
    id: "marketingEfficiency",
    title: "Marketing Efficiency",
    metrics: MARKETING_EFFICIENCY_METRICS.map(m => ({ ...m, value: null })),
  },
  {
    id: "consideration",
    title: "Consideration",
    metrics: CONSIDERATION_METRICS.map(m => ({ ...m, value: null })),
  },
  {
    id: "conversion",
    title: "Conversion",
    metrics: CONVERSION_METRICS.map(m => ({ ...m, value: null })),
  },
]

export const MARKETING_TRENDS_CHARTS = [
  {
    id: "spendVsRevenue",
    title: "Spend vs Total Revenue vs New Customer Revenue",
  },
  { id: "merVsAmer", title: "MER vs aMER" },
]

export const MERCHANDISING_TRENDS_TABLES = [
  { id: "topCollections", title: "Top Collections" },
  { id: "secondPagePaths", title: "2nd Page Paths" },
  { id: "preCheckoutPaths", title: "Pre-Checkout Page Paths" },
  { id: "preAddToCartPaths", title: "Pre Add-to-Cart Page Paths" },
  { id: "topProductsNew", title: "Top Products New" },
  { id: "topProductsRepeat", title: "Top Products Repeat" },
]
